<app-link-with-popup
  [headerText]="'General.PopUp.TankProfileDetails' | translate"
  [linkText]="linkText"
  [isLoading]="isLoading"
  (popupOpen)="onPopupOpen()"
>
  <div class="tank-profile-details-container">
      <div class="tank-profile" *ngIf="(isLoading | async) === false">
      <div class="profile-grid">
        <div class="profile-row">
          <div class="label">Tank Profile Name</div>
          <div class="value">{{ tankProfile?.tankProfileName }}</div>
        </div>
        <div class="profile-row">
          <div class="label">Include Child Organizations</div>
          <div class="value">{{ tankProfile?.includeChildOrganization ? 'Yes' : 'No' }}</div>
        </div>
        <div class="profile-row">
          <div class="label">Include Affiliated Tanks</div>
          <div class="value">{{ tankProfile?.includeAffiliatedOrganization ? 'Yes' : 'No' }}</div>
        </div>
        <div class="profile-row">
          <div class="label">Columns selected</div>
          <div class="value">
            <ul class="columns-list">
              <li *ngFor="let columnName of selectedColumns">
                {{ columnName }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
</div>
</app-link-with-popup>
